import { COUNTRY_LANGUAGE_MAP, Language, type MarketCountryCode } from '@pkgs/api';

export const getLanguageForCountry = (countryCode: MarketCountryCode, currentLanguage: Language): Language => {
  const countryLanguageConfig = COUNTRY_LANGUAGE_MAP.get(countryCode);

  if (!countryLanguageConfig) {
    return Language.en;
  }

  if (countryLanguageConfig.languages.includes(currentLanguage)) {
    return currentLanguage;
  }

  return countryLanguageConfig.defaultLanguage;
};
